export const SOURCESYSTEM_CONTRACTNUMBER_API = "VCCP";
export const suspendedFinancialStatuses = ["suspended"];
export const terminatedFinancialStatuses = ["terminated"];
export const restorationFinancialStatuses = ["active", "reactivated"];
export const REDBALL_FEATURE_TOGGLE = true;
export const suspendedText = "To continue using Reveal, please pay the full amount now. If you need assistance, contact us at ";
export const AUDIENCE = "vccp";
export const DEVLOCALDOMAIN = ["localhost:8070", "localhost:3000", "localhost"];
export const DEVDOMAIN = ["dev.development.fleetmatics.com", "vccp-dev.ebiz.verizon.com"];
export const QADOMAIN = ["test.us.development.fleetmatics.com", "vccp-qa.ebiz.verizon.com"];
export const STAGEUSDOMAIN = [
  "reveal.stage.us.fleetmatics.com",
  "reveal.stage.us.vzconnect.com",
  "vccp-uat.ebiz.verizon.com",
  "connectcustomerportal-uat.verizon.com",
];
export const STAGEEUDOMAIN = ["reveal.stage.eu.fleetmatics.com", "reveal.stage.eu.vzconnect.com"];
export const PRODUSDOMAIN = ["reveal.us.fleetmatics.com", "reveal.us.vzconnect.com", "connectcustomerportal.verizon.com", "reveal.fleetmatics.com"];
export const PRODEUDOMAIN = ["reveal.eu.fleetmatics.com", "reveal.eu.vzconnect.com"];
export const BREAKPOINTS = {
  MOBILE: 480,
  TABLET: 680,
};
export const DEVICE_BREAKPOINTS = {
  MOBILE: 360,
  TABLET: 768,
  DESKTOP: 1024,
  LARGE_DESKTOP: 1440,
};
export const SUPPORTEDLANGCODES = ["de", "fr", "nl"];

// Routes where the AgentCore chat widget must never appear.
// Used by both App.js (to control component mounting) and
// chatBotUtils.js (for legacy hideChatOnLogout calls).
export const CHAT_HIDDEN_ROUTES = [
  "/logout",
  "/sessionexpired",
  "/revealsessionexpired",
  "/permissionerror",
  "/accessdenied",
  "/inactiveaccount",
  "/failedtoaccessaccount",
  "/technicianappointments",
  "/account/technicianappointments",
];

// AgentCore Chat Widget - Supported Region IDs
// Chat is currently available for US (840) and Canada (124).
export const SUPPORTED_CHAT_REGION_IDS = ["840", "124"];

// Chat Widget - Display Handler Delay
// Small delay (in milliseconds) to ensure the old chat widget DOM elements
// are fully rendered before attempting to hide them. This works around a timing
// issue in the legacy chat implementation where elements may not be immediately
// available after route changes.
export const CHAT_DISPLAY_DELAY_MS = 100;

// Local/dev AgentCore runtime (eu-west-1). Decoded ARN:
// arn:aws:bedrock-agentcore:eu-west-1:975050085853:runtime/development_reveal_help_center_agent-D8qRSu9YLD
const DEVELOPMENT_AGENT_CORE_ENDPOINT =
  "https://bedrock-agentcore.eu-west-1.amazonaws.com/runtimes/arn%3Aaws%3Abedrock-agentcore%3Aeu-west-1%3A975050085853%3Aruntime%2Fdevelopment_reveal_help_center_agent-D8qRSu9YLD/invocations?qualifier=LIVE";
// QA / US test AgentCore runtime (us-west-2). Decoded ARN:
// arn:aws:bedrock-agentcore:us-west-2:975050085853:runtime/us_test_reveal_help_center_agent-ScnKjCHeML
const US_TEST_AGENT_CORE_ENDPOINT =
  "https://bedrock-agentcore.us-west-2.amazonaws.com/runtimes/arn%3Aaws%3Abedrock-agentcore%3Aus-west-2%3A975050085853%3Aruntime%2Fus_test_reveal_help_center_agent-ScnKjCHeML/invocations?qualifier=LIVE";
// US staging AgentCore runtime (us-west-2). Decoded ARN:
// arn:aws:bedrock-agentcore:us-west-2:533267101877:runtime/us_staging_reveal_help_center_agent-HvvOiF41ue
const US_STAGING_AGENT_CORE_ENDPOINT =
  "https://bedrock-agentcore.us-west-2.amazonaws.com/runtimes/arn%3Aaws%3Abedrock-agentcore%3Aus-west-2%3A533267101877%3Aruntime%2Fus_staging_reveal_help_center_agent-HvvOiF41ue/invocations?qualifier=LIVE";
// US production AgentCore runtime (us-west-2). Decoded ARN:
// arn:aws:bedrock-agentcore:us-west-2:533267101877:runtime/us_prod_reveal_help_center_agent-k366Kk4P1v
const US_PRODUCTION_AGENT_CORE_ENDPOINT =
  "https://bedrock-agentcore.us-west-2.amazonaws.com/runtimes/arn%3Aaws%3Abedrock-agentcore%3Aus-west-2%3A533267101877%3Aruntime%2Fus_prod_reveal_help_center_agent-k366Kk4P1v/invocations?qualifier=LIVE";

const AGENT_CORE_CONFIGS = {
  local: {
    endpoint: DEVELOPMENT_AGENT_CORE_ENDPOINT,
    authHost: "login.dev.eu.vzconnect.net",
    authClientId: "SAh7El7NgiCDCHnheXlwmWYpMPwr7wrX",
  },
  dev: {
    endpoint: DEVELOPMENT_AGENT_CORE_ENDPOINT,
    authHost: "login.dev.eu.vzconnect.net",
    authClientId: "SAh7El7NgiCDCHnheXlwmWYpMPwr7wrX",
  },
  qa: {
    endpoint: US_TEST_AGENT_CORE_ENDPOINT,
    authHost: "login.test.us.vzconnect.net",
    authClientId: "Ck96aifQP76ytqFxDiN1AvU0Aw891OVB",
  },
  stageUS: {
    endpoint: US_STAGING_AGENT_CORE_ENDPOINT,
    authHost: "login.stage.us.vzconnect.com",
    authClientId: "5eYZWFqh7SgDSlanYrYIk2AUpVe3RUNp",
  },
  us: {
    endpoint: US_PRODUCTION_AGENT_CORE_ENDPOINT,
    authHost: "login.us.vzconnect.com",
    authClientId: "kX88n5FYDnxqitfpIb2Qgw5hybs1tnOb",
  },
};

const getChatLocale = (locale) => {
  const normalizedLocale = (locale || "en-US").replace("_", "-");
  return /^[a-z]{2}-[A-Z]{2}$/.test(normalizedLocale) ? normalizedLocale : "en-US";
};

// The chat widget bundles sit in the Reveal S3 bucket next to the other microsites
// and are served by Reveal's CloudFront. Portal-branded hosts do not serve
// /static-assets, so a root-relative path 404s there and must be pointed at the
// matching Reveal origin. Hosts absent from this map (Reveal domains, localhost)
// resolve the assets on their own origin.
const CHAT_ASSET_ORIGIN_BY_HOST = {
  "vccp-dev.ebiz.verizon.com": "https://dev.development.fleetmatics.com",
  "vccp-qa.ebiz.verizon.com": "https://test.us.development.fleetmatics.com",
  "vccp-uat.ebiz.verizon.com": "https://reveal.stage.us.vzconnect.com",
  "connectcustomerportal-uat.verizon.com": "https://reveal.stage.us.vzconnect.com",
  "connectcustomerportal.verizon.com": "https://reveal.us.vzconnect.com",
};

export const getAgentCoreChatConfig = (environment, locale, host = window.location.host) => {
  const config = AGENT_CORE_CONFIGS[environment];

  // The widget always requires Auth0. Incomplete env entries (staging/prod today)
  // must not be treated as a loadable configuration.
  if (!config?.endpoint || !config.authHost || !config.authClientId) {
    return null;
  }

  const chatLocale = getChatLocale(locale);
  const assetOrigin = CHAT_ASSET_ORIGIN_BY_HOST[host] || "";
  const assetBaseUrl = `${assetOrigin}/static-assets/chat-ui-widget/${chatLocale}`;

  return {
    ...config,
    loaderUrl: `${assetBaseUrl}/loader.js`,
    scriptUrl: `${assetBaseUrl}/chat-widget.js`,
  };
};
